import { render, staticRenderFns } from "./ConfigUserRolesAndRightsDialogAnotherVersion.vue?vue&type=template&id=0eb0b196"
import script from "./ConfigUserRolesAndRightsDialogAnotherVersion.vue?vue&type=script&lang=js"
export * from "./ConfigUserRolesAndRightsDialogAnotherVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports